import {handleActions} from 'redux-actions';
import {ParentPass} from '../constants/models';

const  ParentPassReducers = handleActions({
    SET_PARENT_PASS: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, ParentPass);

export default ParentPassReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/ParentPassReducers.jsx